module.exports = __webpack_public_path__ + "img/youtube.af43e07e.svg";